import A11yDialog from 'a11y-dialog';

export function ModalLink(onShow) {

    const linkOnClick = (event) => {
        const target = event.currentTarget;
        const ref = target.dataset.ref;

        const content = document.getElementById(ref);

        // Create dialog markup
        const dialogEl = document.createElement('div');
        dialogEl.className = 'popup dialog-container';
        dialogEl.id = `markerDialog${ref}`;
        dialogEl.setAttribute('aria-hidden', 'true');

        const dialogOverlay = document.createElement('div');
        dialogOverlay.className = 'dialog-overlay';
        dialogOverlay.tabIndex = '-1';
        dialogEl.appendChild(dialogOverlay);

        const dialogContent = document.createElement('div');
        dialogContent.className = 'dialog-content';
        dialogContent.setAttribute('role', 'alertdialog');
        dialogContent.setAttribute('aria-labelledby', 'dialogTitle');
        dialogEl.appendChild(dialogContent);

        const dialogDocument = document.createElement('div');
        dialogDocument.setAttribute('role', 'document');
        dialogContent.appendChild(dialogDocument);

        const dialogButton = document.createElement('button');
        dialogButton.setAttribute('aria-label', 'Close this dialog window');
        dialogButton.className = 'dialog-close btn btn--solid-tertiary';
        dialogButton.innerHTML = '&times;';
        dialogButton.dataset.a11yDialogHide = `markerDialog${ref}`;
        dialogDocument.appendChild(dialogButton);

        content.hidden = false;
        dialogDocument.appendChild(content);

        // Append dialog to body
        const documentBody = document.querySelector('body');
        documentBody.appendChild(dialogEl);

        // Create dialog instance
        const dialog = new A11yDialog(dialogEl);
        dialog.on('show', function (dialogEl) {
            documentBody.classList.add('no-scroll')
        })

        dialog.on('hide', function (dialogEl) {
            documentBody.classList.remove('no-scroll')
            content.hidden = true;
            documentBody.appendChild(content);
            documentBody.removeChild(dialogEl);
        })

        //Show the dialog
        dialog.show()
    }

    let nodes = document.querySelectorAll('.modal__toggle');
    for (const node of nodes) {
        node.addEventListener('click', function (event) {
            linkOnClick(event)
            event.preventDefault();
        });
	}

}